<div class="settings-tab">
  <form #accountForm="ngForm" class="my-account-form">
    <label for="firstName">First Name</label>
    <mat-form-field>
      <input id="firstName" name="firstName" required matInput
        [(ngModel)]="firstName" #firstNameInput="ngModel">
        @if (firstNameInput.hasError('required')) {
          <mat-error>{{ requiredFieldMsg }}</mat-error>
        }
      </mat-form-field>

      <label for="lastName">Last Name</label>
      <mat-form-field class="form-field">
        <input id="lastName" name="lastName" required matInput
          [(ngModel)]="lastName" #lastNameInput="ngModel">
          @if (lastNameInput.hasError('required')) {
            <mat-error>{{ requiredFieldMsg }}</mat-error>
          }
        </mat-form-field>

        <label for="phoneNumber">Phone Number</label>
        <mat-form-field class="form-field">
          <input id="phoneNumber" name="phoneNumber" [(ngModel)]="phoneNumber"
            matInput [mask]="'(000) 000-0000'" #phoneInput="ngModel">
            @if (phoneInput.hasError('mask')) {
              <mat-error>Invalid phone number</mat-error>
            }
          </mat-form-field>

          <div class="button-container">
            <button mat-raised-button color="primary" (click)="saveChanges()"
              [disabled]="accountForm.invalid">
              Save Changes
            </button>
          </div>
        </form>
      </div>
